import api from "./index";

export interface DocumentTypeListParams {
  title?: string;
  order?: "ASC" | "DESC";
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: DocumentTypeListParams, options?: any) => {
  return api.DocumentTypeTaxonomyApi.list(
    params.title,
    params.order,
    params.offset,
    params.limit,
    options
  );
};
